import { api } from './api';

interface PresignedUrlResponse {
  uploadUrl: string;
  fileKey: string;
  downloadUrl: string;
}

export const getPresignedUrl = async (
  fileName: string,
  fileType: string,
  employeeId: string,
  documentType: string
): Promise<PresignedUrlResponse> => {
  try {
    console.log('🔗 Requesting presigned URL for:', { fileName, fileType, employeeId, documentType });
    const response = await api.post('/files/presigned-url', {
      fileName,
      fileType,
      employeeId,
      documentType,
    });
    console.log('📤 Presigned URL response:', response.data);
    return response.data.data;
  } catch (error) {
    console.error('❌ Failed to get presigned URL:', error);
    throw error;
  }
};

export const uploadFile = async (url: string, file: File): Promise<void> => {
  try {
    console.log('📤 Uploading file to S3:', { url: url.substring(0, 100) + '...', fileSize: file.size });
    const response = await fetch(url, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });
    console.log('✅ Upload response status:', response.status);
    if (!response.ok) {
      throw new Error(`Upload failed with status: ${response.status}`);
    }
  } catch (error) {
    console.error('❌ Failed to upload file:', error);
    throw error;
  }
};

export const getViewPresignedUrl = async (fileKey: string): Promise<string> => {
  try {
    console.log('🔗 Requesting view presigned URL for:', fileKey);
    const response = await api.get(`/files/${encodeURIComponent(fileKey)}`);
    console.log('📤 View presigned URL response:', response.data);
    return response.data.data.downloadUrl;
  } catch (error) {
    console.error('❌ Failed to get view presigned URL:', error);
    throw error;
  }
};


